import { render } from "./ReportCardTemplateManagement.vue?vue&type=template&id=ca9008d8&scoped=true"
import script from "./ReportCardTemplateManagement.vue?vue&type=script&lang=js"
export * from "./ReportCardTemplateManagement.vue?vue&type=script&lang=js"

import "./ReportCardTemplateManagement.vue?vue&type=style&index=0&id=ca9008d8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ca9008d8"]])

export default __exports__